export const MIXPANEL_EVENTS = {
  Global: {
    INTERRUPTION: "GLOBAL_INTERRUPTION",
    // INTERRUPTION
    NO_STRUCTURED_INTERRUPTION_API_RESPONSE: "NO_STRUCTURED_INTERRUPTION_API_RESPONSE",
    // NO STRUCTURED INTERRUPTION API RESPONSE
    API_THROW_INTERRUPTION: "API_THROW_INTERRUPTION",
    // API THROW INTERRUPTION
    UNKNOWN_INTERRUPTION_MODAL: "UNKNOWN_INTERRUPTION_MODAL",
    // UNKNOWN INTERRUPTION MODAL
    LOG_UNKNOWN_INTERRUPTION: "LOG_UNKNOWN_INTERRUPTION",
    // LOG UNKNOWN INTERRUPTION
    RUBY_API_INTERRUPTION: "RUBY_API_INTERRUPTION",
    // RUBY API INTERRUPTION
    JS_API_INTERRUPTION: "JS_API_INTERRUPTION",
    // JS API INTERRUPTION
    APPLICATION_SESSION_EXPIRED: "APPLICATION_SESSION_EXPIRED",
    // APPLICATION SESSION EXPIRED
    API_RETRY_NETWORK_ERROR: "API_RETRY_NETWORK_ERROR",
    // API RETRY NETWORK ERROR
    MAX_RETRIES_REACHED: "MAX_RETRIES_REACHED",
    // MAX RETRIES REACHED
    GENERIC_ERROR_ON_PROCESSING_FLOW: "JS_API_INTERRUPTION_FLOW_ERROR" // GENERIC ERROR ON PROCESSING FLOW
  },
  Flights: {
    SEARCH: "FLIGHTS_SEARCH",
    // SEARCH FLIGHTS
    FILTER_FLIGHTS: "FLIGHTS_FILTER",
    // APPLY FILTER IN FILTERS PANEL
    FILTERS_FLIGHTS_ERROR: "FLIGHTS_FILTERS_INTERRUPTION",
    // ERROR ON APPLY FILTERS
    CHIP_DELETE: "FLIGHTS_CHIP_DELETE",
    // DELETE CHIP FROM FILTER  - UP IN FLIGHTS LIST
    CLEAR_ALL_FILTERS: "FLIGHTS_CLEAR_ALL_FILTERS",
    // CLICK ON DELETE ALL FILTERS - UP IN FLIGHTS LIST
    SORT_FLIGHTS: "FLIGHTS_SORT",
    // APPPLY SORT
    VIEW_MORE_FLIGHTS: "FLIGHTS_VIEW_MORE",
    // VIEW MORE FLIGHTS
    SEARCH_SEE_FLIGHT_DETAILS: "FLIGHTS_SEE_FLIGHT_DETAILS",
    // CLICK IN SEE FLIGHT DETAILS - IN FLIGHT CARD
    SELECT_FLIGHT: "FLIGHTS_SELECT_FLIGHT",
    // SELECT A FLIGHT
    SELECT_FARE_FAMILY: "FLIGHTS_SELECT_FARE_FAMILY",
    // SELECT A FARE FAMILY
    CHANGE_FLIGHT_SEARCH: "FLIGHTS_CHANGE_FLIGHT_SEARCH",
    // CHANGE FLY BUTTON - UP IN FLIGHTS LIST
    // Itinerary page
    CHANGE_FLIGHT_ITINERARY: "FLIGHTS_CHANGE_FLIGHT_ITINERARY",
    // CHANGE FLY BUTTON - IN ITENERARY
    ITINERARY_SEE_FLIGHT_DETAILS: "FLIGHTS_ITINERARY_SEE_FLIGHT_DETAILS",
    // SE DETAILS IN ITENERARY
    ITINERARY_CONTINUE: "FLIGHTS_ITINERARY_CONTINUE",
    //  BUTTON CONTINUE IN ITENERARY
    // Passengers page
    CHECKOUT_PASSENGERS_CONTINUE: "FLIGHTS_CHECKOUT_PASSENGERS_CONTINUE",
    // BUTTON CONTINUE IN PASSSENGERS
    // Payment page
    PAY_ORDER_SUCCESS: "FLIGHTS_PAY_ORDER_SUCCESS",
    // PAY SUCCESS
    PAY_ORDER_ERROR: "FLIGHTS_PAY_ORDER_INTERRUPTION",
    // PAY INTERRUPTION

    // Logs when needs to add payment
    PAY_ORDER_SUCCESS_PAUSE: "FLIGHTS_PAY_ORDER_SUCCESS_PAUSE",
    // PAY SUCCESS PAUSE
    REFUND_POINTS_INTERRUPTION: "FLIGHTS_REFUND_POINTS_INTERRUPTION",
    // REFUND POINTS INTERRUPTION
    PAY_CASH_INTERRUPTION: "FLIGHTS_PAY_CASH_INTERRUPTION",
    // PAY CASH INTERRUPTION
    PAY_POINTS_INTERRUPTION: "FLIGHTS_PAY_POINTS_INTERRUPTION",
    // PAY POINTS INTERRUPTION
    CANCEL_INTERRUPTION: "FLIGHTS_CANCEL_INTERRUPTION" // CANCEL INTERRUPTION
  },
  Hotels: {
    // Search page
    SEARCH: "HOTELS_SEARCH",
    // SEARCH HOTELS
    FILTER_HOTELS: "HOTELS_FILTER",
    // FILTER  HOTELS SUCCES
    FILTERS_HOTELS_ERROR: "HOTELS_FILTERS_INTERRUPTION",
    // FILTER HOTELS ERROR
    CHIP_DELETE: "HOTELS_CHIP_DELETE",
    // DELETE FILTER FROM CHIP - UP ON HOTELS LIST
    CLEAR_ALL_FILTERS: "HOTELS_CLEAR_ALL_FILTERS",
    // CLEAR ALL FILTERS FROM CHIP - UP IN HOTELS LIST
    SORT_HOTELS: "HOTELS_SORT",
    // SORT HOTELS
    LOAD_MORE_HOTELS: "HOTELS_LOAD_MORE",
    // LOAD MORE HOTELS SUCCES -  INFINITE SCROLL
    LOAD_MORE_HOTELS_FROM_MAP: "HOTELS_LOAD_MORE_FROM_MAP",
    // LOAD MORE HOTELS FROM MAP
    LOAD_MORE_HOTELS_ERROR: "HOTELS_LOAD_MORE_INTERRUPTION",
    // LOAD MORE HOTELS  ERROR - INFINITE SCROLL
    SELECT_HOTEL: "HOTELS_SELECT_HOTEL",
    // SELECT HOTEL
    // Details page
    SEE_HOTEL_SERVICES: "HOTELS_SEE_HOTEL_SERVICES",
    // OPEN HOTEL SERVICES
    SEE_HOTEL_MAP_LOCATION: "HOTELS_SEE_HOTEL_MAP_LOCATION",
    // OPEN MAP
    SEE_HOTEL_PHOTOS: "HOTELS_SEE_HOTEL_PHOTOS",
    //  SEE HOTEL PHOTOS
    SEE_HOTEL_DESCRIPTION: "HOTELS_SEE_HOTEL_DESCRIPTION",
    // OPEN HOTEL DESCRIPTION
    SEE_HOTEL_ROOM_DETAILS: "HOTELS_SEE_HOTEL_ROOM_DETAILS",
    // SEE ROOM DETAILS
    SELECT_ROOM: "HOTELS_SELECT_ROOM",
    // SELECT ROOM
    // Guests page
    BOOKING_SUCCESS: "HOTELS_BOOKING_SUCCESS",
    //  FIRTS LOADING IN GUEST FORM VIEW - SUCCESS
    BOOKING_ERROR: "HOTELS_BOOKING_INTERRUPTION",
    //  FIRTS LOADING IN GUEST FORM VIEW - ERROR
    CHECKOUT_GUESTS_INFORMATION_SUCCESS: "CARS_CHECKOUT_GUESTS_INFORMATION_SUCCESS",
    // VALIDATION GUEST DATA SUCCESS
    CHECKOUT_GUESTS_INFORMATION_ERROR: "CARS_CHECKOUT_GUESTS_INFORMATION_INTERRUPTION",
    // VALIDATION GUEST DATA ERROR
    // Payment page
    PAY_ORDER_SUCCESS: "HOTELS_PAY_ORDER_SUCCESS",
    //  PAY HOTEL SUCCESS
    PAY_ORDER_ERROR: "HOTELS_PAY_ORDER_INTERRUPTION",
    // PAY HOTEL ERROR
    REFUND_POINTS_INTERRUPTION: "HOTELS_REFUND_POINTS_INTERRUPTION",
    // REFUND POINTS INTERRUPTION
    ERROR_PROVIDER_CONFIRMATION: "HOTELS_ERROR_PROVIDER_CONFIRMATION",
    // PAY HOTEL ERROR PROVIDER CONFIRMATION
    PAY_CASH_INTERRUPTION: "HOTELS_PAY_CASH_INTERRUPTION",
    // PAY HOTEL CASH INTERRUPTION
    PAY_POINTS_INTERRUPTION: "HOTELS_PAY_POINTS_INTERRUPTION" // PAY HOTEL POINTS INTERRUPTION
  },
  Cars: {
    // Search page
    SEARCH: "CARS_SEARCH",
    // SEARCH
    FILTER_CARS: "CARS_FILTER",
    // FILTER SUCCESS
    FILTERS_CARS_ERROR: "CARS_FILTERS_INTERRUPTION",
    // FILTER ERROR
    CHIP_DELETE: "CARS_CHIP_DELETE",
    // DELETE A CHIP FILTER - UP IN CARS LIST
    CLEAR_ALL_FILTERS: "CARS_CLEAR_ALL_FILTERS",
    // CLEAR ALL FILTERS IN CHIP - UP IN CARS LIST
    SORT_CARS: "CARS_SORT",
    // SORT CARS
    SELECT_CAR: "CARS_SELECT_CAR",
    // SELECT A  CART
    // Details page
    DETAILS_CONTINUE: "CARS_DETAILS_CONTINUE",
    // DONE
    // Driver page
    BOOKING_SUCCESS: "CARS_BOOKING_SUCCESS",
    // IN DETAILS WHEN IS LOADING  THIS ENDPOINTS IS CALLED - SUCCESS
    BOOKING_ERROR: "CARS_BOOKING_INTERRUPTION",
    // IN DETAILS WHEN IS LOADING  THIS ENDPOINTS IS CALLED - ERROR
    CHECKOUT_DRIVER_INFORMATION_SUCCESS: "CARS_CHECKOUT_DRIVER_INFORMATION_SUCCESS",
    // SUCCESS IN VALIDATION CAR DRIVER
    CHECKOUT_DRIVER_INFORMATION_ERROR: "CARS_CHECKOUT_DRIVER_INFORMATION_INTERRUPTION",
    // ERROR IN VALIDATION CAR DRIVER
    // Payment page
    PAY_ORDER_SUCCESS: "CARS_PAY_ORDER_SUCCESS",
    // PAY CAR SUCCESS
    PAY_ORDER_ERROR: "CARS_PAY_ORDER_INTERRUPTION",
    // PAY CAR ERROR
    PAY_ORDER_ERROR_PROVIDER_CONFIRMATION: "CARS_PAY_ORDER_ERROR_PROVIDER_CONFIRMATION",
    // PAY CAR ERROR PROVIDER CONFIRMATION
    REFUND_POINTS_INTERRUPTION: "CARS_REFUND_POINTS_INTERRUPTION",
    // REFUND POINTS INTERRUPTION
    PAY_POINTS_INTERRUPTION: "CARS_PAY_POINTS_INTERRUPTION",
    // PAY POINTS INTERRUPTION
    PAY_CASH_INTERRUPTION: "CARS_PAY_CASH_INTERRUPTION" // PAY CASH INTERRUPTION
  },
  Insurances: {
    // Insurances selection page
    SELECT_PASSENGERS: "INSURANCES_SELECT_PASSENGERS",
    // DONE
    INSURANCES_SELECT_INSURANCE: "INSURANCES_SELECT_INSURANCE",
    // DONE
    INSURANCES_CONTINUE: "INSURANCES_CONTINUE",
    // DONE
    // Travelers page
    CHECKOUT_TRAVELERS_INFORMATION_SUCCESS: "INSURANCES_CHECKOUT_TRAVELERS_INFORMATION_SUCCESS",
    // DONE
    CHECKOUT_TRAVELERS_INFORMATION_ERROR: "INSURANCES_CHECKOUT_TRAVELERS_INFORMATION_INTERRUPTION",
    // DONE
    // Payment page
    PAY_ORDER_SUCCESS: "INSURANCES_PAY_ORDER_SUCCESS",
    // DONE
    PAY_ORDER_ERROR: "INSURANCES_PAY_ORDER_INTERRUPTION" // DONE
  },
  Checkout: {
    SELECT_BIDDING_CURVE_POINT: "CHECKOUT_SET_BIDDING_CURVE_POINT",
    // CHANGE CURVE POSITION
    SELECT_CREDIT_CARD: "CHECKOUT_SELECT_CREDIT_CARD",
    // SELECT A CREDIT CARD
    CVV_ENTERED_SUCCESSFULLY: "CHECKOUT_CVV_ENTERED_SUCCESSFULLY",
    // ENTER A CVV
    CVV_ENTERED_ERROR: "CHECKOUT_CVV_ENTERED_INTERRUPTION" // CVV VALIDATION ERROR
  },
  CreditCard: {
    CREDIT_CARD_ENTERED_SUCCESSFULLY: "CREDIT_CARD_ENTERED_SUCCESSFULLY",
    // ADD NEW CARD PROCCESS SUCCESS
    CREDIT_CARD_ENTERED_ERROR: "CREDIT_CARD_ENTERED_INTERRUPTION",
    // ADD NEW CARD PROCCESS ERROR
    CREDIT_CARD_INVALID: "CREDIT_CARD_INVALID",
    // INVALID DATA IN FORM
    CREDIT_CARD_DELETE: "CREDIT_CARD_DELETE" // DELETE ACTION OF CREDIT CARD
  },
  Home: {
    CLICK_FLIGHT: "HOME_CLICK_FLIGHT_APP",
    // CLICK ON FLIGHT PRODUCT ICON
    CLICK_HOTEL: "HOME_CLICK_HOTEL_APP",
    //  CLICK ON HOTEL PRODUCT ICON
    CLICK_CAR: "HOME_CLICK_CAR_APP",
    // CLICK ON CAR PRODUCT ICON
    RECOMENDATIONS_CLICK_HOTELS: "HOME_RECOMENDATIONS_CLICK_HOTELS",
    // CLICK ON HOTEL RECOMMENDATION
    RECOMENDATIONS_CLICK_FLIGHTS: "HOME_RECOMENDATIONS_CLICK_FLIGHTS",
    // CLICK ON FLIGHTS RECOMMENDATION
    CLAIMS_OPEN_BOOK: "HOME_OPEN_CLAIMS_BOOK" // OPEN CLAIMS BOOK
  },
  Profile: {
    CLICK_PERSONAL_INFORMATION: "PROFILE_CLICK_PERSONAL_INFORMATION",
    // USER MENU - CLICK PERSONAL DATA
    CLICK_FAVORITE_PASSENGERS: "PROFILE_CLICK_FAVORITE_PASSENGERS",
    // USER MENU - CLICK FAVORITE PASSENGERS
    CLICK_CARD_INFORMATION: "PROFILE_CLICK_CARD_INFORMATION",
    //  USER MENU - CLICK  ASSOCIATED CARDS
    CLICK_RESERVATIONS: "PROFILE_CLICK_RESERVATIONS",
    // USER MENU - CLICK RESERVATIONS
    CHANGE_CURRENCY_SUCCESS: "PROFILE_CHANGE_CURRENCY_SUCCESS",
    // CHANGE CURRENCY SUCCESS
    CHANGE_CURRENCY_ERROR: "PROFILE_CHANGE_CURRENCY_INTERRUPTION",
    // CHANGE CURRENCY ERROR
    RESERVATION_DETAIL_HOTEL: "PROFILE_RESERVATION_DETAIL_HOTEL",
    // CLICK ON HOTEL RESERVARTION IN PROFILE
    RESERVATION_DETAIL_FLIGHT: "PROFILE_RESERVATION_DETAIL_FLIGHT",
    // CLICK ON FLIGHT RESERVATION IN PROFILE
    RESERVATION_DETAIL_CAR: "PROFILE_RESERVATION_DETAIL_CAR",
    // CLICK ON CAR RESERVATION IN PROFILE
    POINTS_REFRESHED: "PROFILE_POINTS_REFRESHED",
    // USE REFRESH POINTS  ACTION IN HEADER
    ENTITY_USER_LAPSED_SESSION: "PROFILE_ENTITY_SESSION_LAPSED",
    // THIS IS EXECUTED WHEN A SESSION EXPIRES AND SHOWS THE SESSION EXPIRED MODAL
    LOGOUT: "PROFILE_LOGOUT",
    // CLOSE SESSION
    LOGOUT_ERROR: "PROFILE_LOGOUT_INTERRUPTION",
    // CLOSE SESSION ERROR
    LOGIN_REGISTER_USER: "PROFILE_LOGIN_REGISTER_USER",
    // REGISTER PROCCESS
    LOGIN: "PROFILE_LOGIN",
    // LOGIN
    LOGIN_ERROR: "PROFILE_LOGIN_INTERRUPTION",
    // LOGIN ERROR
    REDIRECT_LAST_SEARCH: "PROFILE_REDIRECT_LAST_SEARCH",
    // THIS IS EXECUTED WHEN A SESSION EXPIRES AND SHOWS THE SESSION EXPIRED MODAL AND REDIRECT TO SEARCH PAGE
    NEW_USER_REGISTRATION: "PROFILE_NEW_USER_REGISTRATION",
    // NEW REGISTER USER
    NEW_USER_REGISTRATION_ERROR: "PROFILE_NEW_USER_REGISTRATION_INTERRUPTION",
    // NEW REGISTER USER ERROR
    CHANGE_PROFILE_INFORMATION: "PROFILE_CHANGE_PROFILE_INFORMATION" // UPDATE PERSONAL DATA IN PROFILE
  },
  Ancillary: {
    CHECK_BAGGAGE_OPTION: "ANCILLARY_CHECK_BAGGAGE_OPTIONS",
    // CHECK BAGGAGE OPTIONS
    UNCHECK_BAGGAGE_OPTION: "ANCILLARY_UNCHECK_BAGGAGE_OPTIONS",
    // UNCHECK BAGGAGE OPTIONS
    APPLY_TO_ALL_BAGGAGE_OPTIONS: "ANCILLARY_APPLY_TO_ALL_BAGGAGE_OPTIONS",
    // APPLY TO ALL BAGGAGE OPTIONS
    SELECT_FLIGHT_SECTOR: "ANCILLARY_SELECT_FLIGHT_SECTOR",
    // SELECT FLIGHT SECTOR
    GO_TO_NEXT_PASSENGER: "ANCILLARY_GO_TO_NEXT_PASSENGER",
    // GO TO NEXT PASSENGER
    GO_TO_PREVIOUS_PASSENGER: "ANCILLARY_GO_TO_PREVIOUS_PASSENGER",
    // GO TO PREVIOUS PASSENGER
    CONTINUE_TO_PAYMENT: "ANCILLARY_CONTINUE_TO_PAYMENT",
    // CONTINUE TO PAYMENT
    CANCEL_ON_BAGGAGE_PAGE: "ANCILLARY_CANCEL_ON_BAGGAGE_PAGE",
    // CANCEL ON BAGGAGE PAGE
    EXIT_ON_PAYMENT_PAGE: "ANCILLARY_EXIT_ON_PAYMENT_PAGE",
    // EXIT ON PAYMENT PAGE
    PAY_ANCILLARY: "ANCILLARY_PAY_ANCILLARY",
    // PAY ANCILLARY
    ANCILLARY_PAYMENT_SUCCESS: "ANCILLARY_PAYMENT_SUCCESS",
    // ANCILLARY PAYMENT SUCCESS
    ANCILLARY_PAYMENT_ERROR: "ANCILLARY_PAYMENT_INTERRUPTION",
    // ANCILLARY PAYMENT ERROR

    // New process
    PAY_ORDER_SUCCESS_PAUSE: "ANCILLARY_PAY_ORDER_SUCCESS_PAUSE",
    // PAY SUCCESS PAUSE
    REFUND_POINTS_INTERRUPTION: "ANCILLARY_REFUND_POINTS_INTERRUPTION",
    // REFUND POINTS INTERRUPTION
    PAY_CASH_INTERRUPTION: "ANCILLARY_PAY_CASH_INTERRUPTION",
    // PAY CASH INTERRUPTION
    PAY_POINTS_INTERRUPTION: "ANCILLARY_PAY_POINTS_INTERRUPTION",
    // PAY POINTS INTERRUPTION
    CANCEL_INTERRUPTION: "ANCILLARY_CANCEL_INTERRUPTION" // CANCEL INTERRUPTION
  }
};